import * as angular from 'angular';

import * as homeCheckupSectionComponent from './home-checkup-section';
import * as inspectionDetailsCard from './inspection-details-card';
import * as notifyMortgageLenderSectionComponent from './notify-mortgage-lender-section';
import * as smartHomeStarterKitSectionComponent from './smart-home-starter-kit-section';
import * as checklistSectionComponent from './checklist-section';
import * as windstormRetrofittingCertificationSectionComponent from './windstorm-retrofitting-certification-section';
import * as noNextStepsNeededSectionComponent from './no-next-steps-section';
import * as progressiveStatusInfoSection from './progressive-status-info-section';

const module = angular.module('checklist-page-components', [
    homeCheckupSectionComponent.module.name,
    inspectionDetailsCard.module.name,
    notifyMortgageLenderSectionComponent.module.name,
    checklistSectionComponent.module.name,
    windstormRetrofittingCertificationSectionComponent.module.name,
    smartHomeStarterKitSectionComponent.module.name,
    progressiveStatusInfoSection.module.name,
    noNextStepsNeededSectionComponent.module.name
]);

export { module };
